
      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "AddCustomerContractNoteResult": [
      "AddCustomerContractNoteSuccess",
      "AddCustomerContractNoteFailure"
    ],
    "BeginPaymentMethodSetupResult": [
      "BeginPaymentMethodSetupSuccess",
      "BeginPaymentMethodSetupFailure"
    ],
    "DeclineContractResult": [
      "DeclineContractSuccess",
      "DeclineContractFailure"
    ],
    "FarmAffiliate": [
      "ExternalOperator",
      "MoovsNetworkOperator",
      "GriddnetOperator",
      "MoovsAiOperator"
    ],
    "FinalizePaymentMethodSetupResult": [
      "FinalizePaymentMethodSetupSuccess",
      "FinalizePaymentMethodSetupFailure"
    ],
    "LoadContractResult": [
      "LoadContractSuccess",
      "LoadContractFailure"
    ],
    "MetadataUnion": [
      "TripChangeMetadata"
    ],
    "Node": [
      "Billing",
      "CancellationPolicy",
      "Comment",
      "Company",
      "Contact",
      "Contract",
      "Driver",
      "DriverAvailability",
      "EmailLog",
      "ExternalOperator",
      "Garage",
      "GriddnetOperator",
      "InsurancePolicy",
      "Invoice",
      "MoovsAiOperator",
      "MoovsNetworkOperator",
      "Operator",
      "OperatorRoute",
      "Payment",
      "PaymentMethod",
      "PaymentRefund",
      "Request",
      "Route",
      "ShuttleRoute",
      "Stop",
      "SubPayment",
      "SubRefund",
      "TeamMember",
      "Term",
      "TrackedFlight",
      "Transaction",
      "Trip",
      "User",
      "UserAccessPermission",
      "Vehicle",
      "VehicleCategory",
      "VehicleChildSeat",
      "VehicleFeature",
      "VehiclePhoto"
    ],
    "PrepareReservationGuestResult": [
      "PrepareReservationGuestSuccess",
      "PrepareReservationGuestFailure"
    ],
    "RepeatTripResult": [
      "RepeatTripSuccess",
      "RepeatTripFailure"
    ],
    "RequestTripCancellationResult": [
      "Trip",
      "RequestTripCancellationFailure"
    ],
    "SelectContractOptionResult": [
      "SelectContractOptionSuccess",
      "SelectContractOptionFailure"
    ],
    "SetPreferredPassengerResult": [
      "SetPreferredPassengerSuccess",
      "SetPreferredPassengerFailure"
    ],
    "SolicitTripChangesResult": [
      "SolicitTripChangesSuccess",
      "SolicitTripChangesFailure"
    ]
  }
};
      export default result;
    